export const SignupTileWeekly = {
  bindings: {
    color: '<',
    icon: '<',
    isBundle: '<',
    isCoupon: '<',
    priceInCents: '<',
    title: '<',
    onClick: '&',
  },

  template: `
    <div class="signup-tile-weekly pr-md-4">
      <div class="d-flex">
        <signup-icon color="$ctrl.color">
          <i class="fa fa-lg text-white" ng-class="$ctrl.icon"></i>
        </signup-icon>
        <div class="d-flex justify-content-between align-items-center ml-3 w-100">
          <div class="details">
            <h5 class="text-black mb-0" ng-bind="$ctrl.title"></h5>
            <button class="btn btn-md btn-link p-0"
              ng-click="$ctrl.onClick()"
              ng-show="$ctrl.isBundle && !$ctrl.isCoupon">
              Remove
            </button>
          </div>
          <div class="d-flex justify-content-between">
            <signup-price value="$ctrl.priceInCents"></signup-price>
          </div>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Signup/SignupTileWeekly.js